var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log"},_vm._l((_vm.history),function(update,i){return _c('div',{key:i,staticClass:"log-item"},[_c('p',{staticClass:"log-message",style:(_vm.getStyles(update))},[_vm._v(" "+_vm._s(_vm.getMessage(update))+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }